module.exports = {"id":"186648","name":"Tamás Kádár","rating":"73","photo":"./data/images/photos/1/186648.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TamasKadar0.json
// module id = 4072
// module chunks = 0